import API from '@/api';
const User = API.get('User');
const Cases = API.get('Cases');

export default ({
  namespaced: true,
  state: {
    patient: [],
    
    // patient info
    dietary: '',
    immunization: '',
    illnesses: '',
    vices: '',
    hospitalizations: '',
    operations: '',

    allergies: [],
    allergy: '',
    note: '',
    allergy_id: '',
    active: null,
    activeIndex: null,
    deleted_items: [],

    family_history: [],
    relationship: '',
    health: '',

    weight: 0,
    height: 0,

    activeFamilyHistoryIndex: null,
    email_options: [],
    phonenumber_options: [],

    vices_alert_message: null,
    dietary_alert_message: null,
    immunization_alert_message: null,
    illnesses_alert_message: null,
    hospitalizations_alert_message: null,
    operations_alert_message: null,
  },

  /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

  getters: {
    patient: state => state.patient.patient,
    id: state => state.patient.patient.id,
    
    fullName: state => {
      var name = '';
      if (state.patient.patient.full_name) {
        name = state.patient.patient.full_name;
      } else {
        if (state.patient.patient.first_name || state.patient.patient.last_name) {
          name = `${state.patient.patient.first_name} ${state.patient.patient.last_name}`;
        } else {
          name = state.patient.email
        }
      }
      return name;
    },

    fullData: state => state.patient,
    
    // patient info
    social: state => state.social,
    dietary: state => state.dietary,
    immunization: state => state.immunization,
    illness: state => state.illness,
    hospitalizations: state => state.hospitalizations,
    operations: state => state.operations,

    allergies: state => state.allergies,
    allergy: state => state.allergy,
    allergy_id: state => state.allergy_id,
    note: state => state.note,
    active: state => state.active,
    activeIndex: state => state.activeIndex,
    deleted_items: state => state.deleted_items,

    family_history: state => state.family_history,
    relationship: state => state.relationship,
    health: state => state.health,

    weight: state => state.weight,
    height: state => state.height,

    activeFamilyHistoryIndex: state => state.activeFamilyHistoryIndex,

    vices: state => state.vices,
    illnesses: state => state.illnesses,

    email_options: state => state.email_options,
    phonenumber_options: state => state.phonenumber_options,

    vices_alert_message: state => state.vices_alert_message,
    dietary_alert_message: state => state.dietary_alert_message,
    immunization_alert_message: state => state.immunization_alert_message,
    illnesses_alert_message: state => state.illnesses_alert_message,
    hospitalizations_alert_message: state => state.hospitalizations_alert_message,
    operations_alert_message: state => state.operations_alert_message,
  },

  /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

  mutations: {
    setPatient(state, patient) {

      console.log("[patient]", patient);

      if(patient.patient.social_factors !== null) {
        state.social = patient.patient.social_factors.replace(/(\\r)|(\\n)/g,"\n");
      }
      
      if(patient.patient.dietary_status !== null) {
        state.dietary = patient.patient.dietary_status.replace(/(\\r)|(\\n)/g,"\n");
      }

      if(patient.patient.immunizations !== null) {
        state.immunization = patient.patient.immunizations.replace(/(\\r)|(\\n)/g,"\n");
      }

      if(patient.patient.illness_injury !== null) {
        state.illness = patient.patient.illness_injury.replace(/(\\r)|(\\n)/g,"\n");
      }

      if(patient.patient.hospitalizations !== null) {
        state.hospitalizations = patient.patient.hospitalizations.replace(/(\\r)|(\\n)/g,"\n");
      }

      if(patient.patient.operations !== null) {
        state.operations = patient.patient.operations.replace(/(\\r)|(\\n)/g,"\n");
      }

      console.log("6 columns");

      state.weight = patient.patient.weight;
      state.height = patient.patient.height;

      if(patient.patient.allergies != null) {
        state.allergies = JSON.parse(patient.patient.allergies);
      }

      // state.doctor_family_history = JSON.parse(patient.patient.family_history);
      
      console.log("[family history instance]", patient.patient.family_history);

      if(patient.patient.family_history != null && patient.patient.family_history.length > 0) {
        state.family_history = JSON.parse(patient.patient.family_history);
      }

      console.log("json data parse");
      
      let illnesses = JSON.parse(patient.patient.illnesses);
      console.log('Illness', typeof illnesses);
      if (typeof illnesses != 'string') {
        state.illnesses = illnesses.join("\n");
      }
      state.illnesses = state.illnesses.replace(/(\\r)|(\\n)/g,"\n");

      console.log("illnesses");

      let vices = JSON.parse(patient.patient.vices);
      if (typeof vices != 'string') {
        state.vices = vices.join("\n");
      }
      state.vices = state.vices.replace(/(\\r)|(\\n)/g,"\n");

      console.log("vices");

      if(typeof patient.patient.email_options === 'string') {
        state.email_options = JSON.parse(patient.patient.email_options);
      }
      
      if(typeof patient.patient.phonenumber_options === 'string') {
        state.phonenumber_options = JSON.parse(patient.patient.phonenumber_options);
        patient.patient.phonenumber_options = JSON.parse(patient.patient.phonenumber_options);
      }

      // patient.firebase_tokens = JSON.parse(JSON.stringify(state.patient.firebase_tokens));
      // patient.devices = JSON.parse(JSON.stringify(state.patient.devices));

      console.log("email / phone options");
      state.patient = patient;

      console.log("[patient]", patient);
    },


    update_vices_alert_message(state, value) { state.vices_alert_message = value },
    update_dietary_alert_message(state, value) { state.dietary_alert_message = value },
    update_immunization_alert_message(state, value) { state.immunization_alert_message = value },
    update_illnesses_alert_message(state, value) { state.illnesses_alert_message = value },
    update_hospitalizations_alert_message(state, value) { state.hospitalizations_alert_message = value },
    update_operations_alert_message(state, value) { state.operations_alert_message = value },


    updateWeight(state, weight) {
      state.weight = weight
    },
    
    // patient info
    updateHeight(state, height) {
      state.height = height
    },
    
    updateDietary(state, dietary) {
      state.dietary = dietary
    },
    
    updateImmunization(state, immunization) {
      state.immunization = immunization
    },
    
    updateIllnesses(state, illnesses) {
      state.illnesses = illnesses
    },

    updateVices(state, vices) {
      state.vices = vices
    },
    
    updateHospitalizations(state, hospitalizations) {
      state.hospitalizations = hospitalizations
    },
    
    updateOperations(state, operations) {
      state.operations = operations
    },

    updateAllergies(state, allergies) {
      state.allergies.push(allergies)
    },

    updateFamilyHistory(state, family_history) {
      state.family_history.push(family_history)
    },

    updateDoctorFamilyHistory(state, doctor_family_history) {
      state.doctor_family_history.push(doctor_family_history)
    },


    /* ################################################ ALLERGY EVENTS ################################################ */

    setActiveAllergy(state, index) {
      var allergy = state.allergies[index];
      
      console.log("allergy");
      console.log(allergy);

      state.allergy = allergy.Allergy
      state.note = allergy.Note

      state.activeIndex = index;
    },

    /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

    updateAllergy(state, allergy) {
      console.log("trigger");
      state.allergy = allergy
    },

    /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

    updateNote(state, note) {
      state.note = note
    },

    /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

    addAllergy(state) {
      var allergy = {
        Allergy: state.allergy,
        Note: state.note,
      }

      state.allergies.push(allergy)
      console.log('ALLERGIES LIST', state.allergies)
    },

    /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

    clearAllergy(state) {
      state.id = null
      state.allergy = ''
      state.note = ''
      // state.type = ''
    },

    /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */
    
    editAllergy(state) {
      let parsed_allergies = state.allergies;
      
      parsed_allergies[state.activeIndex].Allergy = state.allergy;
      parsed_allergies[state.activeIndex].Note = state.note;

      state.allergies = parsed_allergies;
    },

    /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

    removeAllergy(state) {
      let parsed_allergies = state.allergies;
      parsed_allergies.splice(state.activeIndex, 1);
      state.allergies = parsed_allergies;
    },

    /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

    pushNewAllergy(state, allergy) {
      state.allergies.push(allergy);
    },

    /* ################################################ ALLERGY EVENTS ################################################ */






    /* ################################################ FAMILY HISTORY EVENTS ################################################ */

    setActiveFamilyHistory(state, index) {
      var family_history = state.family_history[index];
      console.log(family_history);

      state.relationship = family_history.relationship
      state.health = family_history.health
      state.activeFamilyHistoryIndex = index;
    },

    /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

    updateRelationship(state, relationship) {
      state.relationship = relationship
    },

    /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

    updateHealth(state, health) {
      state.health = health
    },

    /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

    addFamilyHistory(state) {
      var family_history = {
        relationship: state.relationship,
        health: state.health,
      }

      state.family_history.push(family_history)
      console.log('ALLERGIES LIST', state.family_history)
    },

    /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

    clearFamilyHistory(state) {
      state.relationship = ''
      state.health = ''
    },

    /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */
    
    editFamilyHistory(state) {
      state.family_history[state.activeFamilyHistoryIndex].relationship = state.relationship;
      state.family_history[state.activeFamilyHistoryIndex].health = state.health;
    },

    /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

    removeFamilyHistory(state) {
      state.family_history.splice(state.activeFamilyHistoryIndex, 1);
    },

    /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

    pushNewFamilyHistory(state, family_history) {
      state.family_history.push(family_history);
    },

    /* ################################################ FAMILY HISTORY EVENTS ################################################ */
    
    
    clearStoreData(state) {
      state.patient = [];
      state.social = '';
      state.dietary = '';
      state.immunization = '';
      state.illness = '';
      state.hospitalizations = '';
      state.operations = '';
    },

    /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

    clearErrorMessages(state) {
      state.vices_alert_message = null;
      state.dietary_alert_message = null;
      state.immunization_alert_message = null;
      state.illnesses_alert_message = null;
      state.hospitalizations_alert_message = null;
      state.operations_alert_message = null;
    }
  },

  /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

  actions: {
    async save({getters}, id) {
      var items = ['social', 'dietary', 'immunization', 'illness', 'hospitalizations', 'operations'];
      // 'operations'
      var payload = {
        is_patient: 1,
      }

      items.map(item => {
        switch (item) {
          case 'social':
            if (getters.social) payload.social_factors = getters.social
            break;
          case 'dietary':
            if (getters.dietary) payload.dietary_status = getters.dietary
            break;
          case 'immunization':
            if (getters.immunization) payload.immunizations = getters.immunization
            break;
          case 'illness':
            if (getters.illness) payload.illness_injury = getters.illness
            break;
          case 'operations':
            if (getters.operations) payload.operations = getters.operations
            break;
          case 'hospitalizations':
            if (getters.hospitalizations) payload.hospitalizations = getters.hospitalizations
            break;
        }
      })
      let response = await User.updatePatient(id, payload);
      console.log("[patient/save]", response);
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    async compiled_patient_info({getters}) {

      var items = ['patient_id', 'allergies', 'vices', 'dietary', 'immunization', 'illnesses', 'hospitalizations', 'operations', 'family_history', 'height', 'weight'];
      // 'operations'
      var payload = {
        is_patient: 1,
      }

      items.map(item => {
        switch (item) {
          case 'patient_id':
            if (getters.patient) payload.patient_id = getters.patient.id
            break;
          case 'allergies':
            if (getters.allergies) payload.allergies = getters.allergies
            break;
          case 'family_history':
            if (getters.family_history) payload.family_history = getters.family_history
            break;
          case 'vices':
            if (getters.vices) payload.vices = getters.vices
            break;
          case 'dietary':
            if (getters.dietary) payload.dietary_status = getters.dietary
            break;
          case 'immunization':
            if (getters.immunization) payload.immunizations = getters.immunization
            break;
          case 'illnesses':
            if (getters.illnesses) payload.illnesses = getters.illnesses
            break;
          case 'operations':
            if (getters.operations) payload.operations = getters.operations
            break;
          case 'hospitalizations':
            if (getters.hospitalizations) payload.hospitalizations = getters.hospitalizations
            break;
          case 'height':
            if (getters.height) payload.height = getters.height
            break;
          case 'weight':
            if (getters.weight) payload.weight = getters.weight
            break;
        }
      })

      console.log("[patient payload]", payload);
      return payload;
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    async getPatientCasesTotal(state, id) {
      var response = await Cases.getByPatientId(id);
      return response.data.total;
    }
  }
})